import React from 'react'
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
//import MensCollImage from "https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/MEN_CAT_yn3te1"; // Path to your image
//import WomensCollImage from 'https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/FEM_CAT_ss9x2m'; // Path to your image



const GenderCollectionSection = () => {
  return (
    <section className="py-16 px-4 lg:px-0">
  <div className="container mx-auto flex flex-col md:flex-row gap-8">

    {/* MEN */}
    <Link
      to="/collections/all?gender=Men"
      className="relative flex-1 bg-black"
    >
      <div className="relative w-full aspect-[2/3]">
        <img
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/MEN_CAT_yn3te1"
          alt="Men's Collection"
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </div>

      <div className="absolute bottom-8 left-8 bg-white/90 p-4">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          VESHH-EON Men
        </h2>
        <span className="text-sm font-medium underline">Shop Now</span>
      </div>
    </Link>

    {/* WOMEN */}
    <Link
      to="/collections/all?gender=Women"
      className="relative flex-1 bg-black"
    >
      <div className="relative w-full aspect-[2/3]">
        <img
          src="https://res.cloudinary.com/dmrlotfsv/image/upload/t_VESHH-EON_WEBSITE/FEM_CAT_ss9x2m"
          alt="Women's Collection"
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </div>

      <div className="absolute bottom-8 left-8 bg-white/90 p-4">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          VESHH-EON Women
        </h2>
        <span className="text-sm font-medium underline">Shop Now</span>
      </div>
    </Link>

  </div>
</section>


  )
}

export default GenderCollectionSection
